export default __webpack_public_path__ + "static/media/logo-humano-blanco.481f2149.png";